import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _snakeCase from "lodash/snakeCase";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { trackAuthStepChange } from "../../actions";
import { StepSlugs, YodleeStepSlugs } from "../../constants";
import { // transunion
isTransunionDuplicate, isTransunionNoData, isTransunionFailVerification, isTransunionOtherThinFile, isRateLimited, isBlocked, isDeceased, notEnoughData, hasTUDuplicateEmail // tracking
, getTrackingAuthTypeUsed, getTrackingLastTUAuthenticateResult, getTrackingCreditPurpose, getTrackingState, getTrackingHasTUCustomerCreated, getTrackingTUVerificationType // yodlee
, getSelectedProviderId, getSearchResultsForQuery, getIndexOfProviderIdInSearchResults, getMfaTypeFromProviderAccount, getSelectedProviderAccount, getSelectedProviderAccountStatusCode } from "../../selectors";
import { getAnalytics } from "../../lib/lazy-requires/analytics";
import track from "./track";
import { isAuthStep, isRegisterStep, isYodleeStep, isTUVerificationSlug, getStandardYodleeParams } from "./track-utils";

var trackMembershipEnrollment = function trackMembershipEnrollment(state, payload) {
  var previousStep = payload.previousStep;
  var identity = state.identity;
  var authType = getTrackingAuthTypeUsed(identity);

  if (previousStep && isRegisterStep(previousStep) && authType) {
    getAnalytics().track('membership_enrollment_changed', {
      feature_name: 'membership',
      enrollment_change_type: 'enroll',
      additional_attributes: {
        authentication_provider: authType.toUpperCase()
      }
    });
  }
};

var trackCreditScoreEnrollment = function trackCreditScoreEnrollment(state, payload) {
  var previousStep = payload.previousStep;
  var identity = state.identity;
  var tuCustomerCreated = getTrackingHasTUCustomerCreated(identity);

  if (previousStep && isTUVerificationSlug(previousStep) && tuCustomerCreated) {
    getAnalytics().track('credit_score_enrollment_changed', {
      feature_name: 'credit_score',
      additional_attributes: {
        credit_bureau: 'TRANSUNION',
        verification_type: getTrackingTUVerificationType(identity)
      },
      enrollment_change_type: 'enroll'
    });
  }
};

var trackAuthStepPageImpression = function trackAuthStepPageImpression(step) {
  if (_get(step, 'entityName')) {
    getAnalytics().track('page_impression', {
      entity_name: _snakeCase("legacy_step_".concat(step.entityName))
    });
  }
};

export default createReducer(_defineProperty({}, trackAuthStepChange, function (state, payload) {
  var newStep = payload.newStep,
      previousStep = payload.previousStep,
      previousStepShownAt = payload.previousStepShownAt;
  var stepperHasAdvanced = previousStep && newStep.key > previousStep.key;
  var stepperIsComplete = previousStep && !newStep;
  var identity = state.identity;
  var trackingState = getTrackingState(identity); // Track membership enrollment on register success

  trackMembershipEnrollment(state, payload); // Track credit score enrollment on create TU customer success

  trackCreditScoreEnrollment(state, payload); // step change on the first step doesn't make sense, only track if a previousStep exists

  if (previousStep) {
    var previousStepData = {
      step: previousStep.onStep
    }; // for authentication complete steps attach the type of auth that was used

    if (isAuthStep(previousStep)) {
      previousStepData.auth_type = getTrackingAuthTypeUsed(identity);
    }

    if (previousStep.slug === StepSlugs.VERIFICATION_QUESTIONS) {
      previousStepData.success = getTrackingLastTUAuthenticateResult(identity);
    }

    if (previousStep.slug === StepSlugs.CREDIT_PURPOSE) {
      previousStepData.reason = getTrackingCreditPurpose(identity);
    } // all yodlee onboarding step get shared attributes


    if (isYodleeStep(previousStep)) {
      previousStepData = _objectSpread(_objectSpread({}, previousStepData), getStandardYodleeParams(identity));
    }

    if (previousStep.slug === YodleeStepSlugs.SEARCH) {
      var hasSearchResults = !!getSearchResultsForQuery(identity);
      var providerId = getSelectedProviderId(identity); // if there are search results for the current search query then the user must be viewing
      // search results - otherwise they are seeing the top 8 providers

      previousStepData.choice_location = hasSearchResults ? 'search-results' : 'top-8';

      if (hasSearchResults) {
        // where in the search results was the user's choice
        previousStepData.result_placement = getIndexOfProviderIdInSearchResults(identity, providerId);
      }
    } // it's useful to know which direction the user is moving in the flow


    previousStepData.nextStepDirection = stepperHasAdvanced || stepperIsComplete ? 'forward' : 'backward';
    previousStepData.timeStepShown = (new Date() - previousStepShownAt) / 1000;
    track("step:".concat(previousStep.slug, ":completed"), trackingState, previousStepData);
  }

  if (!stepperIsComplete) {
    var nextStepData = {
      step: newStep.onStep
    }; // if it's the blocked step then track the reason

    if (newStep.slug === StepSlugs.ACCOUNT_BLOCKED) {
      if (isTransunionDuplicate(identity) || hasTUDuplicateEmail(identity)) nextStepData.blockedReason = 'duplicate';else if (isTransunionNoData(identity)) nextStepData.blockedReason = 'noData';else if (isTransunionFailVerification(identity)) nextStepData.blockedReason = 'failVerification';else if (isTransunionOtherThinFile(identity)) nextStepData.blockedReason = 'other';else if (isRateLimited(identity)) nextStepData.blockedReason = 'rateLimited';else if (isBlocked(identity)) nextStepData.blockedReason = 'statusBlocked';else if (isDeceased(identity)) nextStepData.blockedReason = 'isDeceased';else if (notEnoughData(identity)) nextStepData.blockedReason = 'notEnoughData';
    } // all yodlee onboarding step get shared attributes


    if (isYodleeStep(newStep)) {
      nextStepData = _objectSpread(_objectSpread({}, nextStepData), getStandardYodleeParams(identity));
    } // if it's an mfa step add the mfa type


    if (newStep.slug === YodleeStepSlugs.MFA) {
      var providerAccount = getSelectedProviderAccount(identity);
      nextStepData.mfa_type = getMfaTypeFromProviderAccount(providerAccount);
    }

    if (newStep.slug === YodleeStepSlugs.ERROR) {
      nextStepData.yodlee_status_code = getSelectedProviderAccountStatusCode(identity);
    } // track step page impression using nwjs-analytics


    trackAuthStepPageImpression(newStep); // old tracking event

    track("step:".concat(newStep.slug, ":shown"), trackingState, nextStepData);
  }
}));